(ns app.front.view.group.reporting.statcan-spreadsheet
  "New excel-based statcan report of 2023 vintage. Replaces previous PDF report, expected to one
   day be replaced by a new API-based reporting solution."
  (:require [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.reporting.common :as reporting-common]
            [app.front.view.group.reporting.download-button :as rdb]
            [app.front.view.group.reporting.list :as report-list]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [reagent.core :as r]
            [schema.core :as s]))

(defn view [match]
  (r/with-let [*params (r/atom (reporting-common/current-year-month true))]
    (let [tr       (<sub [::gas/group-tr])
          group-id (<sub [::gas/group-id])]
      [reporting-common/report-page
       match
       tr
       [:section
        [reporting-common/month-select-with-button
         (util/mmap {:title     [:<>
                                 [:h3.mb-4 (tr [:reporting.statcan/building-and-demolition-permits])]
                                 [:h4 (tr [:reporting.statcan/issuance-report])]]
                     :on-change (fn [month year]
                                  (reset! *params (util/mmap month year)))}
                    tr)]
        [:div.lg:p-4.mt-4
         [rdb/generate-button (util/mmap {:query (merge {:group-id    group-id
                                                         :report-type :reporting/statcan-spreadsheet-report}
                                                        @*params)}
                                         tr)]]
        [report-list/list-section (util/mmap {:report-type :reporting/statcan-spreadsheet-report} tr)]]])))


(def route
  {:name        :view/group.reporting.statcan-spreadsheet
   :view        view
   :breadcrumb  {:fallback (fn [{:keys [tr match]}]
                             [:view/group.reporting.statcan-spreadsheet
                              (-> match :parameters :path)
                              (tr [:reporting.statcan/issuance-tab])])}
   :parameters  {:path {:group-id s/Int}}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [params]
                                (let [group-id (-> params :path :group-id)]
                                  (>evt [::reporting-common/fetch-reports group-id])
                                  (>evt [::reporting-common/fetch-group group-id])))}]})
